import * as React from "react";
const SvgPlusIcon = props => <svg width="1em" height="1em" viewBox="0 0 14 14" fill="#fff" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.125 6.125V7H7v6.125h-.875V7H0v-.875h6.125V0H7v6.125h6.125Z" /></svg>;
export default SvgPlusIcon;